import * as Blockly from 'blockly';
import { adjustColorBrightness } from './blocky-types.types';

class RoundedConstantProvider extends Blockly.blockRendering.ConstantProvider {
  constructor() {
    super();
  }

  override init(): void {
    super.init();
    this.CORNER_RADIUS = 8;
    this.MEDIUM_PADDING = 10;
  }
}

class LightBorderPathObject extends Blockly.blockRendering.PathObject {
  override applyColour(block: Blockly.BlockSvg): void {
    super.applyColour(block);
    const primary = block.style.colourPrimary;
    if (!primary) return;
    const lighterBorder = adjustColorBrightness(primary, 20);
    if (block.outputConnection) {
      const lighterTop = adjustColorBrightness(primary, 30);
      const gradientId = 'grad_' + block.id.replace(/[^a-zA-Z0-9]/g, '_');
      let defs = document.querySelector('svg.blocklySvg defs') as SVGDefsElement | null;
      if (!defs) {
        const svg = document.querySelector('svg.blocklySvg');
        if (svg) {
          defs = document.createElementNS('http://www.w3.org/2000/svg', 'defs');
          svg.insertBefore(defs, svg.firstChild);
        }
      }
      if (defs) {
        if (!document.getElementById(gradientId)) {
          const gradient = document.createElementNS('http://www.w3.org/2000/svg', 'linearGradient');
          gradient.id = gradientId;
          gradient.setAttribute('x1', '0%');
          gradient.setAttribute('y1', '0%');
          gradient.setAttribute('x2', '0%');
          gradient.setAttribute('y2', '100%');
          const stop1 = document.createElementNS('http://www.w3.org/2000/svg', 'stop');
          stop1.setAttribute('offset', '0%');
          stop1.setAttribute('stop-color', lighterTop);
          const stop2 = document.createElementNS('http://www.w3.org/2000/svg', 'stop');
          stop2.setAttribute('offset', '100%');
          stop2.setAttribute('stop-color', primary);
          gradient.appendChild(stop1);
          gradient.appendChild(stop2);
          defs.appendChild(gradient);
        }
        this.svgPath.setAttribute('fill', `url(#${gradientId})`);
      }
      this.svgPath.setAttribute('stroke', lighterBorder);
      this.svgPath.setAttribute('stroke-width', '1.5');
    } else {
      this.svgPath.setAttribute('stroke', lighterBorder);
      this.svgPath.setAttribute('stroke-width', '1.5');
    }

    // EXPERT_ blocks always get a black dashed border with stroke-width 3
    if (block.type.startsWith('EXPERT_')) {
      this.svgPath.setAttribute('stroke', '#000000');
      this.svgPath.setAttribute('stroke-width', '3');
      this.svgPath.setAttribute('stroke-dasharray', '8 4');
    }
  }
}

class LightBorderThrasosRenderer extends Blockly.thrasos.Renderer {
  constructor(name: string) {
    super(name);
  }

  override makeConstants_(): Blockly.blockRendering.ConstantProvider {
    return new RoundedConstantProvider();
  }

  override makePathObject(root: SVGElement, style: Blockly.Theme.BlockStyle): Blockly.blockRendering.IPathObject {
    return new LightBorderPathObject(root as SVGElement, style, this.getConstants());
  }
}

Blockly.blockRendering.register('light_border_thrasos', LightBorderThrasosRenderer);
